export default "__VITE_ASSET__CeN6xpnx__"